export default "__VITE_ASSET__D96oVIDo__"